module.exports = {
      id: "author-avator-usage",
      viewBox: "0 0 102 102",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#author-avator",
      toString: function () {
        return this.url;
      }
    }